import { render, staticRenderFns } from "./dealer.vue?vue&type=template&id=9b42cfb6&scoped=true"
import script from "./dealer.vue?vue&type=script&lang=js"
export * from "./dealer.vue?vue&type=script&lang=js"
import style0 from "./dealer.vue?vue&type=style&index=0&id=9b42cfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b42cfb6",
  null
  
)

export default component.exports